var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "#C1D8E5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.35191 1.44309C7.5759 0.852302 8.42357 0.852302 8.64826 1.44309L10.0972 5.45683C10.1987 5.72283 10.457 5.89993 10.7454 5.89993H14.3061C14.9641 5.89993 15.2511 6.71891 14.7338 7.12001L12.1999 9.39987C12.0864 9.48713 12.0034 9.6081 11.963 9.74543C11.9225 9.88275 11.9265 10.0294 11.9745 10.1643L12.8999 14.0863C13.1253 14.7163 12.3959 15.2574 11.8443 14.8696L8.40257 12.6856C8.2847 12.6028 8.14415 12.5583 8.00008 12.5583C7.85602 12.5583 7.71547 12.6028 7.5976 12.6856L4.15586 14.8696C3.60498 15.2574 2.87491 14.7156 3.1003 14.0863L4.02566 10.1643C4.07366 10.0294 4.07771 9.88275 4.03722 9.74543C3.99672 9.6081 3.91378 9.48713 3.80027 9.39987L1.26638 7.12001C0.748407 6.71891 1.03679 5.89993 1.69336 5.89993H5.25411C5.3943 5.90039 5.53134 5.85828 5.64708 5.77916C5.76282 5.70004 5.85181 5.58764 5.90228 5.45683L7.35191 1.44309Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarIcon);
export default __webpack_public_path__ + "static/media/star-icon.0d47385f.svg";
export { ForwardRef as ReactComponent };